import { ACHFundTransaction, ACHFundTransactionRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchACHFundTransaction({ bearer }: { bearer?: string }) {
  const [fetching, setFetching] = useState(false);
  const [achFundTransaction, setAchFundTransaction] = useState<ACHFundTransaction>();

  async function fetchAchFundTransaction(params: ACHFundTransactionRequest) {
    try {
      setFetching(true);
      const res = await api.fetchACHFundTransaction(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setAchFundTransaction(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  function resetAchFundTransaction() {
    setAchFundTransaction(undefined);
  }

  return { fetching, achFundTransaction, fetchAchFundTransaction, resetAchFundTransaction };
}
